// extracted by mini-css-extract-plugin
module.exports = {"person":"Person_person__3hP5A","person-name":"Person_person-name__3EFNy","person-role":"Person_person-role__sEnBI","person-image":"Person_person-image__D-oMi"};